import React from "react";

const Resources = () => {
    // Array of resource card data
    const resourceCards = [
        {
            id: 1,
            title: "Information for <br> Upcoming Election",
            description: "",
            imagePath: "/info-icon.png",
            href:"https://www.harrisvotes.com/Voter/View-information-for-upcoming-Elections",
            openInSameTab:false
        },
        {
            id: 2,
            title: "What's on my ballot?",
            description: "",
            imagePath: "/ballot-icon.png",
            href:"https://www.harrisvotes.com/Voter/Whats-on-my-Ballot",
            openInSameTab:false
        },
        {
            id: 3,
            title: "Where to vote?",
            description: "",
            imagePath: "/location-icon.png",
            href:"https://www.harrisvotes.com/Vote-Centers",
            openInSameTab:false
        },
        {
            id: 4,
            title: "Search for Voter ID",
            description: "",
            imagePath: "/search-id-icon.png",
            href:"https://www.hctax.net/Voter/Search.cshtml",
            openInSameTab:false
        },
        {
            id: 5,
            title: "Mail Ballot Application",
            description: "",
            imagePath: "/mail-ballot-icon.png",
            href:"https://files.harrisvotes.com/harrisvotes/prd/docs/VotingInfo/2023%20HCCO%20Mail-in-Ballot_EN.pdf",
            openInSameTab:false
        },
        {
            id: 6,
            title: "FAQ's for Elections",
            description: "",
            imagePath: "/faq-icon.png",
            href:"/faq",
            openInSameTab:true
        },
        {
            id: 7,
            title: "Glossary",
            description: "",
            imagePath: "/glossary-icon.png",
            // isWide: true,
            href:"https://www.sos.texas.gov/elections/laws/glossary.shtml",
            openInSameTab:false
        },
        {
            id: 7,
            title: "Voter Registration",
            description: "",
            imagePath: "/Vorter_Registration.png",
            // isWide: true,
            href:"https://www.hctax.net/Voter/Registration",
            openInSameTab:false
        }
    ];

    return (
        <div className="">
            <div className="w-full px-20px max-w-[1336px] mx-auto lg-xl:mt-20 lg:mt-15 mt-10" id="resources">
                <div className="flex justify-between items-center flex-col lg-xl:flex-row">
                    <div className="lg-xl:w-[40.6%] w-full">
                        <h2 className="font-bold lg-xl:text-left text-center lg-xl:text-[50px] lg-xl:leading-[65px] lg:text-[40px] lg:leading-[55px] sm:text-[32px] sm:leading-[45px] text-[28px] leading-[40px] text-customRed tracking-normal uppercase font-fira pb-2.5">RESOURCES</h2>
                        <p className="lg:text-22px lg:leading-[35.2px] text-18px leading-[24px] tracking-normal font-fira font-normal mb-4 text-lightBlack">
                            For the last <span className="font-bold">eighty years</span> political scientists have studied
                            why some people vote and some people do not. One
                            factor is consistent across all the studies: <span className="font-bold">When a trusted
                                person encourages someone to vote, that person is more
                                likely to vote.</span> Voters are also more likely to vote when
                            they are informed about the issues.
                        </p>

                        <p className="lg:text-22px lg:leading-[35.2px] text-18px leading-[24px] tracking-normal font-fira font-normal text-lightBlack">
                            <span className="font-bold">Fired Up To Vote provides information</span> relevant to state,
                            county, and local elections and is a software tool for
                            people to engage with voters they know personally to
                            encourage them to VOTE!
                        </p>
                    </div>

                    <div className="lg-xl:w-[57.55%] lg:w-9/12 w-full lg-xl:mt-0 mt-8">
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-[24px]">
                            {resourceCards.map((card) => (
                                <a
                                    target={`${!card?.openInSameTab ? '_blank' : ''}`} href={card?.href ? card?.href : '#'}
                                    key={card.id}
                                    className={`border group border-customRed rounded-[12px] lg:p-[28px] p-20px flex items-center cursor-pointer bg-white hover:bg-customRed hover:text-white ${card.isWide ? "sm:col-span-2 sm:w-1/2 sm:mx-auto" : ""}`}
                                >
                                    <div className="mr-3.5">
                                        <img
                                            src={card.imagePath}
                                            alt={card.title}
                                            className="group-hover:invert"
                                        />
                                    </div>
                                    <div>
                                        <p className="lg:text-22px lg:leading-[29px] text-18px leading-[24px] tracking-normal font-fira font-medium" dangerouslySetInnerHTML={{ __html: card.title }}></p>
                                    </div>
                                </a>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Resources;